/**
 * IA NAS AGENCIAS — VIDEO 2/9 (Dado)
 * SlideType: data-anchor | 10s | 720x900
 */
import React from "react";
import {AbsoluteFill, useCurrentFrame, interpolate, Easing} from "remotion";
import {TOKEN_PRESETS, FONT_PRESETS} from "../../templates/carrossel/EditorialTechNews";

const CLAMP = {extrapolateLeft: "clamp" as const, extrapolateRight: "clamp" as const};
const fadeIn = (frame: number, start: number, end: number) =>
  interpolate(frame, [start, end], [0, 1], { extrapolateRight: CLAMP });
const scaleIn = (frame: number, start: number, end: number) =>
  interpolate(frame, [start, end], [0.85, 1], { extrapolateRight: CLAMP, easing: Easing.out(Easing.ease) });

export const IAA02Dado: React.FC = () => {
  const frame = useCurrentFrame();
  const tokens = TOKEN_PRESETS.dark;
  const accent = "#00DF82";
  const glow = 20 + Math.sin(frame * 0.05) * 8;

  return (
    <AbsoluteFill style={{backgroundColor: tokens.bg}}>
      <div style={{position: "absolute", inset: 0, backgroundImage: "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)", backgroundSize: "40px 40px"}} />
      <div style={{position: "absolute", top: 30, left: 50, opacity: fadeIn(frame, 0, 10), fontFamily: FONT_PRESETS.mono, fontSize: 13, fontWeight: 500, letterSpacing: 2, textTransform: "uppercase", color: tokens.muted}}>IA NAS AGENCIAS</div>
      <div style={{position: "absolute", top: 180, left: 50, opacity: fadeIn(frame, 5, 20), transform: `scale(${scaleIn(frame, 5, 15)})`, fontFamily: FONT_PRESETS.serif, fontSize: 88, fontWeight: 800, color: accent, lineHeight: 1, textShadow: `0 0 ${glow}px rgba(0,223,130,0.3)`}}>73%</div>
      <div style={{position: "absolute", top: 295, left: 50, width: interpolate(frame, [17, 27], [0, 40], {extrapolateRight: CLAMP, easing: Easing.out(Easing.ease)}), height: 3, background: accent}} />
      <div style={{position: "absolute", top: 320, left: 50, right: 50, opacity: fadeIn(frame, 20, 35), fontFamily: FONT_PRESETS.serif, fontSize: 24, fontWeight: 400, lineHeight: 1.4, color: tokens.body}}>Das agências que não adotaram IA nos últimos 18 meses. Essa é a taxa que fechou.</div>
      <div style={{position: "absolute", bottom: 40, left: 50, right: 50, display: "flex", justifyContent: "space-between", opacity: fadeIn(frame, 40, 50)}}>
        <span style={{fontFamily: FONT_PRESETS.sans, fontSize: 15, color: tokens.muted}}>@guilhermeribeiro.ai</span>
        <span style={{fontFamily: FONT_PRESETS.sans, fontSize: 13, color: tokens.muted}}>2/9</span>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
